import { createContext, useContext, type ReactNode } from 'react'
import { useOrgUsersApi } from 'src/api/db/apiOrgUsers'
import { Roles } from '../consts'
import { TEMP_AGENT_FORCE_LOGGED_IN } from './tempAgentAuthBypass'

const AdminOverrideContext = createContext<boolean | null>(null)

/** Landing-page demo: show the customer workspace even if the viewer is staff. */
export const ForceCustomerViewer = ({ children }: { children: ReactNode }) => (
  <AdminOverrideContext.Provider value={false}>
    {children}
  </AdminOverrideContext.Provider>
)

/**
 * Hook to check if the current user is an admin (role === 1)
 * Admin users have role = 1, visitor/customer users have role = 2
 */
export const useIsAdmin = () => {
  const override = useContext(AdminOverrideContext)
  const { orgUser } = useOrgUsersApi()
  if (override !== null) return override
  if (TEMP_AGENT_FORCE_LOGGED_IN) return true
  return orgUser?.data?.role?.id === Roles.SUPERADMIN
}
